import React, { useEffect } from 'react'
import Breadcrumb from '../components/Breadcrumb'
import NavBar from '../components/Navbar'
import ServiceDetailsArea from '../components/ServiceDetailsArea'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import FooterFour from '../components/Footer'

const ServiceDetails = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const slider = t('services-slider', { returnObjects: true })
  const service = slider.find((service) => service.id == id)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <NavBar />

      <Breadcrumb title={service.title} />

      <ServiceDetailsArea
        content={service.content}
        images={service.images}
        title={service.title}
        layout={service.layout}
      />

      <FooterFour />
    </>
  )
}

export default ServiceDetails
